var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M51.9684 1.03361C50.5902 -0.344538 48.3522 -0.344538 46.9681 1.03361L26.4961 21.4998L6.02993 1.03361C4.64589 -0.344538 2.40786 -0.344538 1.02971 1.0395C-0.348445 2.41766 -0.348445 4.64979 1.02971 6.02795L21.5018 26.5L1.02971 46.972C-0.348445 48.3561 -0.348445 50.5941 1.0356 51.9723C2.41375 53.3504 4.64589 53.3504 6.02404 51.9723L26.4961 31.5002L46.9681 51.9723C48.3522 53.3504 50.5902 53.3504 51.9684 51.9664C53.3465 50.5882 53.3465 48.3561 51.9684 46.9779L31.4963 26.5L51.9684 6.02795C53.3465 4.64979 53.3465 2.41177 51.9684 1.03361Z","fill":"#ED4B92"}));
}

X.defaultProps = {"width":"53","height":"53","viewBox":"0 0 53 53","fill":"none"};

module.exports = X;

X.default = X;
